
export default {
    data() {
        return {
            currentThemeProgressBuffer: 0
        }
    },
    computed: {
        actionEventProps() {
            return {
                insightTitle: this.bookInsight.title,
                currentThemeSecondsListened: this.calculateThemeSecondsListened(),
                totalTimeSpentListening: this.elapsedDuration,
                insightSlug: this.bookInsight.slug,
                insightGenre: this.bookInsight.genre,
                themeTitle: this.currentAudioSource.title
            }
        },
        currentThemeProgressSeconds() {
            return this.currentAudioSource.duration * (this.currentAudioSource.progress / 100);
        }
    },
    methods: {
        calculateThemeSecondsListened() {
            const secondsListened = this.currentThemeProgressSeconds - this.currentThemeProgressBuffer;
            this.updateThemesSecondsListenedBuffer();
            return secondsListened.toFixed(2);
        },
        updateThemesSecondsListenedBuffer() {
            this.currentThemeProgressBuffer = this.currentThemeProgressSeconds;
        },
        $_dispatchPlayerActionEvent(action, props = {}, bookInsight = this.bookInsight) {
            const customEvents = {
                forward: {
                    event:"bi-audio-bookpage-fwd",
                    action:"fwd"
                },
                rewind: {
                    event: "bi-audio-bookpage-rwd",
                    action: "rwd"
                },
                play: {
                    event : "bi-audio-bookpage-play",
                    action : "play"
                },
                pause: {
                    event : "bi-audio-bookpage-pause",
                    action : "pause"
                },
                progress: {
                    event: "bi-audio-bookpage-time-spent-in-player",
                    action: "progress"
                }
            };


            const eventProps = {
                ...customEvents[action],
                ...props
            }

            if (bookInsight.hasOwnProperty("slug")) {
                eventProps.insightSlug = bookInsight.slug;
            }

            if (bookInsight.hasOwnProperty("genre")) {
                eventProps.insightGenre = bookInsight.genre.name;
            }

            if (action === "progress") {
                this.$store.dispatch("NonfictionPlayer/updateTotalElapsedTimeDuration");
            }

            const customEventsProperties = this.$_buildEventProperties(eventProps);
            const eventName = customEvents[action].event;

            this.$_segmentTrackEvent(eventName, customEventsProperties);
            this.$_gtmTrackEvent(customEventsProperties);
        }
    }
}
